<template>
    <div class="vx-row">
        <div class="vx-col md:w-5/12 w-full mt-2 pl-0">
            <div class="vx-card mt-2 p-6 height-card">
                <div class="component">
                    <span class="text-title-news">
                    {{ $t("news") }}
                    <div v-if="!showDonutChart" class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    </span>
                </div>
                <div class="component">
                    <span class="text-sub">
                        {{ $t('shareOfVoice.correlation') }}
                    </span>
                </div>
                <div id="chart" class="mt-8">
                    <vue-apex-charts
                        v-if="showDonutChart"
                        type="donut"
                        :options="donutNewsChart.chartOptions"
                        :series="donutNewsChart.series"
                        height="300">
                    </vue-apex-charts>
                </div>
            </div>
        </div>

        <div class="vx-col md:w-7/12 w-full mt-2 p-0">
            <div class="vx-card mt-2 p-6 height-card" @mouseover="topicCardHover" @mouseout="topicCardOut">
                <div class="component">
                    <span class="text-title-news">
                    {{ $t("news") }}
                    <div v-if="!showBarChart" class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    </span>
                </div>
                <div class="component">
                    <span class="text-sub">
                        {{ $t('shareOfVoice.quantity') }}
                    </span>
                </div>
                <div id="chart" :class="{'topic-scroll' : topicHover,'topic-hidden': !topicHover}">
                    <vue-apex-charts 
                        style="min-height:20rem;"
                        v-if="showBarChart"
                        :height="heightChartTopic"
                        type="bar" 
                        :options="barChartNews.chartOptions" 
                        :series="barChartNews.series">
                    </vue-apex-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
    components: {
        VueApexCharts
    },
    props: {
        dateRange: {
            type: Object
        },
        refreshData: {default: 0},
        topics: {default:null}
    },
    watch: {
        refreshData: function (newVal, oldVal) {
            this.initScreen();
        }
    },
    data(){
        return {
            //show chart
            topicHover: false,
            showDonutChart: false,
            showBarChart: false,
            optionGroupTopics: [],
            heightChartTopic: 0,

            donutNewsChart: {
                series: [40,50,60,70,80],
                chartOptions: {
                chart: {
                    type: "donut",
                    toolbar: {
                        show: true
                    },
                },
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        distributed: true,
                        horizontal: true,
                        dataLabels: {
                        position: 'bottom'
                        },
                    }
                },
                colors: this.colorByTopic(),
                responsive: [
                    {
                    breakpoint: 480,
                    options: {
                        chart: {
                        width: 200
                        },
                        legend: {
                        position: "bottom"
                        }
                    }
                    }
                ],
                labels: [],
                yaxis: {
                    tickAmount: 5,
                    labels: {
                    style: {
                        cssClass: "text-grey fill-current"
                    },
                    formatter: function(val) {
                        if (Number(val) === val && val % 1 !== 0) {
                        return kFormatter(val).toFixed(1);
                        } else {
                        return kFormatter(val);
                        }
                    }
                    },
                    grid: {
                    show: false
                    }
                },
                legend: {
                    show: false,
                    position: "bottom",
                    // offsetX: 0,
                    // offsetY: 50
                    markers: {
                    fillColors: [
                        "#2F7FED",
                        "#003F94",
                        "#F2994A",
                        "#F2C94C",
                        "#828282",
                        "#BDBDBD"
                    ]
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                        background: 'transparent',
                        labels: {
                            show: true,
                            value: {
                            show: true,
                            fontSize: '14px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            color: '#B9B9C3',
                            // offsetY: -60,
                            formatter: function (val, ch) {
                                let total = ch.globals.seriesTotals.reduce((a, b) => {
                                return a + b
                                }, 0);
                                let percent = total !== 0 ? (val / total) * 100 : 0;
                                return percent.toFixed(0) + "%";
                            }
                            },
                            name: {
                            show: true,
                            fontSize: '14px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            color: '#5E5873',
                            // offsetY: -10,
                            formatter: function (val) {
                                if (Number(val) === val && val % 1 !== 0) {
                                return kFormatter(val).toFixed(1);
                                } else {
                                return kFormatter(val);
                                }
                            }
                            },
                            total: {
                            show: true,
                            fontSize: '14px',
                            label: '',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            color: '#5E5873',
                            // offsetY: -10,
                            formatter: function (ch) {
                                let val = ch.globals.seriesTotals.sort((a, b) => {
                                return b - a
                                }, 0);
                                let total = ch.globals.seriesTotals.reduce((a, b) => {
                                return a + b
                                }, 0);
                                let percent = (total !=0 ? ((val[0]/total) * 100).toFixed(0) : 0 ) + '%'
                                return kFormatter(percent);
                            }
                            }
                        }
                        }
                    }
                }
                }
            },
            barChartNews: {
                series: [],
                chartOptions: {
                    chart: {
                        type: 'bar',
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true,
                            distributed: true
                        }
                    },
                    colors: this.colorByTopic(),
                    dataLabels: {
                        enabled: true,
                        style: {
                            colors: ['#fff']
                        }
                    },
                    xaxis: {
                        categories: [0,1,2,3,4],
                        labels: {
                            formatter: function (val) {
                                if (val >= 1000) return (val/1000).toFixed(0) + 'K';
                                if (val < 1000) return val.toFixed(0);
                                return val.toFixed(1);
                            }
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                if (val >= 1000) return (val/1000).toFixed(1) + 'K'
                                return val;
                            }
                        }
                    },
                    legend: {
                        show: false,
                        position: "bottom",
                        // offsetX: 0,
                        // offsetY: 50
                        markers: {
                        fillColors: [
                            "#2F7FED",
                            "#003F94",
                            "#F2994A",
                            "#F2C94C",
                            "#828282",
                            "#BDBDBD"
                        ]
                        }
                    },
                },
            }
        }
    },
    methods: {
        topicCardHover:function(){
            this.topicHover = true;
        },
        topicCardOut: function(){
            this.topicHover = false
        },
        getDataNewsByTopic: function(){
            this.showBarChart = false;
            this.showDonutChart = false;
            const payload  = {
                from: this.dateRange.startDate,
                to: this.dateRange.endDate,
                topicId: null,
                topics: this.topics
            }
            this.$processor.post('user-data/get-mention-topic', payload).then((topic) =>  {
                this.heightChartTopic = 0;
                let chartHeight = topic.data.length * 40;
                if (chartHeight < 300) {
                    this.heightChartTopic = 260;
                }else this.heightChartTopic = chartHeight;
                topic.data = topic.data.sort(function(a, b) {
                    if (a.countMention > b.countMention) return -1;
                    if (a.countMention < b.countMention) return 1;
                    return 0;
                });
                this.barChartNews.chartOptions.xaxis.categories = [];
                this.donutNewsChart.chartOptions.plotOptions.pie.donut.labels.total.label = '';
                let labels = [...topic.data.map(x => {
                    return x.topicName;
                })]
                this.barChartNews.chartOptions.xaxis.categories = labels;
                this.donutNewsChart.chartOptions.labels = labels;
                this.donutNewsChart.chartOptions.plotOptions.pie.donut.labels.total.label = topic.data[0].topicName;
                this.barChartNews.series = [
                    {
                    name: this.$t('news'),
                    data: [...topic.data.map(x => {
                        return x.countMention;
                    })]
                    }
                ];
                this.donutNewsChart.series = [...topic.data.map(x => {
                    return x.countMention;
                })]
                this.showBarChart = true;
                this.showDonutChart = true;
            });
        },
        getTopicGroups: function(){
            return new Promise((resolve,reject) =>{
                this.$business.post('/topic-group/find-by-conditions',{}).then((res) =>{
                this.optionGroupTopics = res.data;
                if(this.optionGroupTopics.length > 0){
                    this.optionGroupTopics = this.optionGroupTopics.map(el =>{
                    return {
                        label:el.groupName,
                        value:el.id,
                        color:el.color,
                        checkedGroup: false
                    }
                    })
                }
                resolve();
                }).catch(() => reject())
            })
        },
        colorByTopic: function(){
            let colors = []
            colors = ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e','#f48024', '#69d2e7'];
            return colors;
        },
        initScreen(){
            this.getTopicGroups().then(() => {
                this.getDataNewsByTopic();
            })
            this.colorByTopic();
        }
    },
    async created(){
        this.initScreen();
    }
}
function kFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}
</script>

<style scoped>
.height-card {
  height: 396px;
}
.text-title-news {
    font-size: 18px;
    font-weight: bold;
    color: #5E5873;
}
.text-sub {
    font-size: 14px;
    color: #B9B9C3;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: revert;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -0.24s;
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -0.12s;
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px;
  }

  50%,
  100% {
    top: 16px;
    height: 4px;
  }
}
.topic-scroll{
  margin-top: 0px;
  max-height:260px;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  }
.topic-scroll::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
  border-radius: 5px;
}

 .topic-scroll::-webkit-scrollbar {
	width: 10px;
	background-color: #F5F5F5;
}

 .topic-scroll::-webkit-scrollbar-thumb {
	background-color: #cccccc;
	border: 1px solid #cccccc;
}
.topic-hidden {
  max-height:260px;
  overflow-y: hidden;
}
</style>